import { render, staticRenderFns } from "./headPage.vue?vue&type=template&id=ba6206a4&scoped=true&"
import script from "./headPage.vue?vue&type=script&lang=js&"
export * from "./headPage.vue?vue&type=script&lang=js&"
import style0 from "./headPage.vue?vue&type=style&index=0&id=ba6206a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6206a4",
  null
  
)

export default component.exports